import { Instagram, Phone, Mail, Menu, X, MessageCircle } from "lucide-react";
import { useState, useEffect } from "react";

export default function Header({ content }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const brand = content?.brand || {};

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { href: "#hero", label: "Início" },
    { href: "#itens", label: "Itens" },
    { href: "#galeria", label: "Galeria" },
    { href: "#sobre", label: "Sobre" },
    { href: "#reservar", label: "Reservar" },
  ];

  const close = () => setOpen(false);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-md shadow-md" : ""
      }`}
      style={{ backgroundColor: "var(--ff-sky)" }}
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 flex items-center justify-between h-20">
        <a
          href="#hero"
          className="flex items-center gap-2 hover-zoom"
          data-testid="header-logo-link"
        >
          <div className="relative">
            <span className="font-display text-2xl md:text-3xl font-bold leading-none" style={{ color: "var(--ff-text)" }}>
              {brand.name?.split(" ")[0] || "Fantastic"}
            </span>
            <span
              className="font-fancy text-xl md:text-2xl block leading-none -mt-1"
              style={{ color: "white" }}
            >
              {brand.name?.split(" ").slice(1).join(" ") || "Fun"}
            </span>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="font-display text-base font-medium hover:text-[var(--ff-peach)] transition-colors duration-200 hover-zoom"
              data-testid={`nav-${l.label.toLowerCase()}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          {brand.instagram_url && (
            <a
              href={brand.instagram_url}
              target="_blank"
              rel="noreferrer"
              className="hover-zoom p-2 rounded-full bg-[var(--ff-cream)] border-2 border-[var(--ff-peach)]"
              data-testid="header-instagram"
            >
              <Instagram size={20} style={{ color: "var(--ff-peach)" }} />
            </a>
          )}
          {brand.phone && (
            <a
              href={`https://wa.me/${brand.phone.replace(/\s/g, "")}`}
              target="_blank"
              rel="noreferrer"
              className="hover-zoom p-2 rounded-full bg-[var(--ff-cream)] border-2 border-[var(--ff-peach)]"
              data-testid="header-whatsapp"
            >
              <MessageCircle size={20} style={{ color: "var(--ff-peach)" }} />
            </a>
          )}
          <a
            href="#reservar"
            className="ff-btn ff-btn-primary !py-2.5 !px-5 !text-sm"
            data-testid="header-cta-reservar"
          >
            Reservar
          </a>
        </div>

        <button
          className="lg:hidden p-2"
          onClick={() => setOpen((s) => !s)}
          aria-label="menu"
          data-testid="header-menu-toggle"
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-[var(--ff-peach)]/30 shadow-md">
          <div className="max-w-7xl mx-auto px-5 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={close}
                className="font-display py-2 text-lg"
                data-testid={`nav-mobile-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            ))}
            {brand.instagram_url && (
              <a
                href={brand.instagram_url}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2 font-display py-2"
              >
                <Instagram size={18} /> @{brand.instagram}
              </a>
            )}
            {brand.phone && (
              <a
                href={`https://wa.me/${brand.phone.replace(/\s/g, "")}`}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2 font-display py-2"
              >
                <MessageCircle size={18} /> WhatsApp
              </a>
            )}
            <a href="#reservar" onClick={close} className="ff-btn ff-btn-primary mt-2">
              Reservar Agora
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
